module.exports = __webpack_public_path__ + "static/media/sign-up-bg.ecca89ca.png";